import { HttpParams } from '@angular/common/http';

export interface ODataArgs {
  skip: number;
  pageSize: number;
  count: boolean;
  top: number;
  expand: string;
  filter: string;
  orderby: string;
  byData: object;
}

export interface ODataResult<T> {
  count: number | null;
  items: T[];
  nextPageLink: string;
  query: string;
}

export const odataParams = (params: HttpParams, args: Partial<ODataArgs>) => {
  if (!args) {
    return params;
  }

  if (args.skip) {
    params = params.set('$skip', args.skip.toString());
  }

  if (args.pageSize) {
    params = params.set('pageSize', args.pageSize.toString());
  }

  if (args.count) {
    params = params.set('$count', 'true');
  }

  if (args.top) {
    params = params.set('$top', args.top.toString());
  }

  if (args.expand) {
    params = params.set('$expand', args.expand);
  }

  if (args.filter) {
    params = params.set('$filter', args.filter);
  }

  if (args.orderby) {
    params = params.set('$orderby', args.orderby);
  }

  if (args.byData) {
    params = params.set('byData', JSON.stringify(args.byData));
  }

  return params;
};
